<template>
  <v-container fluid class="pt-0 px-0">
    <check-in-app-bar v-on:sync="loadData" v-if="!loading"></check-in-app-bar>
    <loading-spinner v-if="loading"> </loading-spinner>
    <v-container v-else class="px-0">
      <check-in-header-card
        v-if="checkin.archiveDate == null"
      ></check-in-header-card>
      <talking-points v-if="tab == 0"></talking-points>
      <goals v-if="tab == 1" :edit-ids="attendeeIds"></goals>
      <action-items v-if="tab == 2"></action-items>
      <check-in-history v-if="tab == 3"></check-in-history>
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import CheckInAppBar from "@/components/layout/CheckInAppBar";
import CheckInHeaderCard from "@/components/checkin/CheckInHeaderCard";
import TalkingPoints from "@/components/checkin/TalkingPoints";
import Goals from "@/components/goals/Goals";
import ActionItems from "@/components/checkin/ActionItems";
import CheckInHistory from "@/components/checkin/CheckInHistory";
export default {
  name: "CheckInDetails",
  components: {
    CheckInAppBar,
    CheckInHeaderCard,
    TalkingPoints,
    ActionItems,
    Goals,
    CheckInHistory
  },
  data: () => ({
    loading: false
  }),
  computed: {
    attendeeIds() {
      return this.checkin.attendees.map(x => x.id);
    },
    isComplete() {
      return this.checkin.completeDate != null;
    },
    ...mapGetters({
      tab: "checkin/tab",
      checkin: "checkin/checkin",
      profile: "profile/profile"
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch("checkin/getCheckIn", {
          definitionId: this.$route.params.definitionId,
          id: this.$route.params.id
        }),
        this.$store.dispatch(
          "checkin/getCheckInHistory",
          this.$route.params.definitionId
        ),
        this.$store.dispatch("checkin/setDrawer", false),
        this.$store.dispatch("checkin/setTab", 0)
      ])
        .then(() => {
          if (this.$route.meta.isStart) {
            this.$store.dispatch("checkin/startCheckin");
          }
          if (this.checkin.archiveDate != null && !this.$route.params.id) {
            this.$store.dispatch("checkin/setTab", 3);
          }
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading Check In."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
